import { render, staticRenderFns } from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=template&id=081ed294&scoped=true&lang=pug"
import script from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=081ed294&prod&lang=scss"
import style1 from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=style&index=1&id=081ed294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081ed294",
  null
  
)

export default component.exports